<form>
    <cp-electric-vehicle [evFormGroup]="formGroup" #CPEVForm [pressedSubmit]="pressedSubmit"></cp-electric-vehicle>
    <cp-signup-footer-controls (nextClicked)="submitForm()" focusOnError="true"></cp-signup-footer-controls>
    <div class="idonthaveEVContainer">
        <button class="btn btn-link idonthaveEVContainer" (click)="skipEV()">{{"I don’t have an EV" | T }}</button>
    </div>
</form>